import { Box } from '@mui/material'
import React from 'react'
import theme from '../themes/theme'

// Uppercase the first LETTER of each word and lowercase the rest, skipping any
// leading punctuation so "(MULTI SELECT)" -> "(Multi Select)" (not "(multi Select)").
// e.g. "ROUND HIGHLIGHTS" -> "Round Highlights"
const toTitleCase = (str) =>
    str.replace(/\S+/g, (word) => word.toLowerCase().replace(/[a-z]/, (c) => c.toUpperCase()));

const RequiredMark = () => (
    <Box component="span" sx={{ color: '#F04438', marginLeft: '2px' }}>*</Box>
);

// Recursively transform the label's string leaves: optionally title-case them and
// inject the required asterisk immediately after the FIRST piece of text. Injecting
// inline (rather than appending after the whole node) keeps the "*" next to the
// wording even when the label is a wide flex layout (e.g. a row with a "Select all").
const decorate = (node, ctx) => {
    if (typeof node === 'string') {
        const text = ctx.capitalize ? toTitleCase(node) : node;
        if (ctx.required && !ctx.injected.value && node.trim() !== '') {
            ctx.injected.value = true;
            return [text, <RequiredMark key="required-mark" />];
        }
        return text;
    }
    if (Array.isArray(node)) return React.Children.map(node, (child) => decorate(child, ctx));
    if (React.isValidElement(node) && node.props?.children != null) {
        return React.cloneElement(node, undefined, decorate(node.props.children, ctx));
    }
    return node;
};

const CustomLabel = ({children, sx ={}, capitalize = true, required = false, ...props}) => {
    const ctx = { capitalize, required, injected: { value: false } };
    const content = decorate(children, ctx);
    return (
        <Box component="label" className='custom-label' sx={{ color: theme.palette.customColors.g500, marginBottom: '8px', display: 'block', fontSize: "0.875rem", textTransform: 'none',...sx}} {...props}>
            {content}
            {/* Fallback: no text leaf was found to attach the asterisk to. */}
            {required && !ctx.injected.value && <RequiredMark />}
        </Box>
    )
}

export default CustomLabel
